import { useApiWithErrors, ApiError, GoneError } from '@axiom/ui';
import type { AfcSubmission } from '@axiom/validation';
import { useParams } from 'react-router';

import { SubmissionsUtil } from '../utils/submissions-util';
import { SubmissionApi } from '../api/submission-api';

interface Args {
  submissionId?: AfcSubmission['id'];
}

export const useEngagementInterviewTalentData = ({
  submissionId: argSubmissionId,
}: Args = {}) => {
  const { submissionId: urlSubmissionId } = useParams();
  const submissionId = urlSubmissionId ?? argSubmissionId;
  const [response] = useApiWithErrors(
    submissionId ? SubmissionApi.readSubmissionDetails(submissionId) : undefined
  );
  let invalidSubmissionRequest = false;
  const submissionData = response?.data;
  if (response instanceof ApiError) {
    if (response instanceof GoneError) {
      invalidSubmissionRequest = true;
    } else {
      throw response;
    }
  }

  const currentInterviewSubmission =
    SubmissionsUtil.getInterviewingCandidates(submissionData);
  const candidateOpps =
    currentInterviewSubmission?.positions.flatMap(
      position => position.candidateOpportunities
    ) || [];

  const interviewCount = candidateOpps.length;
  return {
    candidateOpps,
    currentInterviewSubmission,
    interviewCount,
    invalidSubmissionRequest,
  };
};
